import createLoader from './createLoader'

export { createLoader }
